var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWashcompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.977,
    height: 53.822,
    viewBox: "0 0 78.977 53.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(0.75 1.061)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y2: 10.289,
    transform: "translate(33.439 13.429)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 28.295,
    transform: "translate(19.292 23.717)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M69.95,56.617h7.716V41.184a5.144,5.144,0,0,0-5.145-5.145H58.375L49.567,20.626A5.145,5.145,0,0,0,45.1,18.034H20.611a5.144,5.144,0,0,0-4.728,3.118L9.5,36.04H5.645A5.144,5.144,0,0,0,.5,41.184V56.617H8.216",
    transform: "translate(-0.5 -12.322)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 30.867,
    transform: "translate(23.15 44.295)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 7.716,
    cy: 7.716,
    r: 7.716,
    transform: "translate(7.717 36.579)",
    fill: "rgba(243,235,25,0.4)",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 7.716,
    cy: 7.716,
    r: 7.716,
    transform: "translate(54.017 36.579)",
    fill: "rgba(243,235,25,0.4)",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M94.4,6.629a7.762,7.762,0,1,1-7.165-4.777,7.839,7.839,0,0,1,4.149,1.194",
    transform: "translate(-19.023 -1.255)",
    fill: "rgba(243,235,25,0.4)",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M88.633,6.678l2.985,2.985L100.576.707",
    transform: "translate(-23.409 -0.707)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 3.889,
    cy: 3.889,
    r: 3.889,
    transform: "translate(11.544 40.406)",
    fill: "#fff",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 3.889,
    cy: 3.889,
    r: 3.889,
    transform: "translate(57.844 40.406)",
    fill: "#fff",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashcompleteIcon);
export default __webpack_public_path__ + "static/media/washcomplete-icon.7f16a5d8215f4e5dec06f5a4fc4c1608.svg";
export { ForwardRef as ReactComponent };